import { render } from "./smallIconButton.vue?vue&type=template&id=f0e115d0&scoped=true"
import script from "./smallIconButton.vue?vue&type=script&lang=js"
export * from "./smallIconButton.vue?vue&type=script&lang=js"

import "./smallIconButton.vue?vue&type=style&index=0&id=f0e115d0&lang=scss&scoped=true"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0e115d0"]])

export default __exports__